import { render, staticRenderFns } from "./Course-Educenter.vue?vue&type=template&id=4576c926"
import script from "./Course-Educenter.vue?vue&type=script&lang=js"
export * from "./Course-Educenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports